import { render, staticRenderFns } from "./applicant-tracker.vue?vue&type=template&id=51993e36&scoped=true"
import script from "./applicant-tracker.vue?vue&type=script&lang=js"
export * from "./applicant-tracker.vue?vue&type=script&lang=js"
import style0 from "./applicant-tracker.vue?vue&type=style&index=0&id=51993e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51993e36",
  null
  
)

export default component.exports